"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function TitlesIcon(_a) {
    var _b = _a.height, height = _b === void 0 ? "14px" : _b, _c = _a.color, color = _c === void 0 ? "currentColor" : _c, style = _a.style;
    return (react_1.default.createElement("svg", { height: height, viewBox: "0 0 1024 1024", fill: "none", style: style },
        react_1.default.createElement("path", { fill: color, d: "M56.888889 56.888889h682.666667v113.777778H56.888889zM512 512h455.111111v113.777778H512zM341.333333 170.666667h113.777778v796.444444H341.333333z" }),
        react_1.default.createElement("path", { fill: color, d: "M682.666667 568.888889h113.777777v398.222222h-113.777777z" })));
}
exports.default = TitlesIcon;
//# sourceMappingURL=index.js.map